import { type DocumentReference } from './firebase/firestore/adaptor';

export interface IRoutingAction<T = unknown> {
  icon: string;
  name: string;

  do(ref: DocumentReference<T>): void;
}
